import Mailcheck from "mailcheck"

const LoginMailCheck = {
  init() {
    Mailcheck.defaultTopLevelDomains.push("church", "bz")
    this.timer = null
    this.bindToEmailInput()
  },

  bindToEmailInput() {
    const target = $("#email_address")

    // Set a timeout so we're not changing on every keystroke
    target.on("input", event => {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.performCheck(event.target)
      }, 700)
    })

    // Perform a check on user select & deselect
    target.on("focus blur", event => {
      this.performCheck(event.target)
    })

    // Perform the check on page load
    this.performCheck(target)
  },

  performCheck(element) {
    if ($(element).length) {
      $(element).mailcheck({
        suggested: (element, suggestion) => {
          const target = $($(element).siblings(".mailcheck_suggestion")[0])
          target.html(`Did you mean ${suggestion.full}?`)
          target.attr("data-mailcheck-suggestion", suggestion.full)
          target.on("click", event => {
            const target = $(event.target)
            const value = target.attr("data-mailcheck-suggestion")
            if (value) {
              $("#email_address").val(value)
              target.html("")
              target.attr("data-mailcheck-suggestion", null)
            }
          })
        },
        empty: element => {
          const target = $($(element).siblings(".mailcheck_suggestion")[0])
          target.html("")
          target.attr("data-mailcheck-suggestion", null)
        }
      })
    }
  },
  initialize() {
    $(document).on("turbolinks:load", () => this.init())
  }
}

export default LoginMailCheck
